/**
 * "Your quests here" in the atlas details strip (Tome UI Round 3, the next program's E2): the
 * character's active quests that lead to the shown place, each opening the journal on it. The atlas
 * stays open behind the journal, so closing the journal returns to the same place.
 */
import React from 'react';
import type { Helix2000Character } from '../../../../shared/CharacterTypes';
import { windowBridge } from '../../framework/windowBridge';
import { focusJournalQuest, questJournalOwner } from '../Quest/questJournalFocus';
import { atlasQuestsAt } from './atlasQuests';

export const WorldMapQuestNotes: React.FC<{ player: Helix2000Character | null | undefined; placeId: string }> = ({ player, placeId }) => {
  if (!player?.quests) return null;
  const quests = atlasQuestsAt(player.quests, placeId);
  if (quests.length === 0) return null;
  const owner = questJournalOwner(player);
  return <span className="world-map-strip-quests" data-testid={`world-map-quests-${placeId}`}>
    Your quests here:
    {quests.map((q) => <button key={q.id} type="button" className="world-map-strip-quest" data-quest-ready={q.ready || undefined}
      aria-label={`Open ${q.title} in the quest journal`} title={q.ready ? 'Ready to turn in' : undefined}
      onClick={() => { focusJournalQuest(owner, q.id); windowBridge.open('quests'); }}>
      {q.title}
    </button>)}
  </span>;
};
